import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import { store, persistor } from "./redux/store";
import { PersistGate } from "redux-persist/integration/react";
import App from "./App";
import ErrorBoundary from "./components/ErrorBoundary";
import reportWebVitals from "./reportWebVitals";
import ReactGA from "react-ga4";

const GA_ID = process.env.REACT_APP_GA_MEASUREMENT_ID;
if (GA_ID) {
  // GA4 is the single source of truth for page_view. The gtag config sends the
  // initial page_view (send_page_view default = true) and GA4 Enhanced
  // Measurement ("page changes based on browser history events") sends one
  // page_view per SPA route change. The app sends NO manual page_views (see
  // App.jsx), so there is exactly one page_view per view. Custom events
  // (vendor_view, view_item, add_to_cart, …) are still sent via react-ga4.
  ReactGA.initialize(GA_ID);
}

ReactDOM.render(
  <ErrorBoundary>
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <App />
      </PersistGate>
    </Provider>
  </ErrorBoundary>,
  document.getElementById("root")
);

reportWebVitals();
